var generateStyle = function generateStyle() {
  return {
    sdk: {
      height: '100%'
    }
  };
};
export default generateStyle;